const parseJSONData = (dataset: DOMStringMap, attribute: string) => {
  const json = dataset[attribute]

  if (json) {
    return JSON.parse(json)
  } else {
    throw new Error(`Failed to parse JSON in dataset attribute ${attribute}`)
  }
}

export default parseJSONData
